import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { serverInfo } from "../../../../../App";
import messiRonaldo from "../../.././../../Assets/Images/messiRonaldo.png";
import shahrukhSalman from "../../.././../../Assets/Images/shahrukhSalman.png";
import "./FanGroupSearch.css";

const FanGroupSearch = (props) => {

  const { imageCdnUrl } = useContext(serverInfo);



  return (
    <div>
      <div className="searchUserFirst">
        <h6 className="mx-3 py-2 text-light">Fan Group</h6>
        <div className="underLineBlackSearch"></div>

        <div className="my-2">
          <div className="row py-2">
            {props.searchSuggFanGroup?.map((fangroup) => (
              <div className="col-md-6">
                <div className="rounded-3">
                  <Link to={`/group/${fangroup?.slug}`}>
                    <img
                      src={imageCdnUrl + fangroup?.banner}
                      className="img-fluid w-100"
                      alt=""
                    />
                  </Link>

                  <div className="d-flex justify-content-around bg-danger p-3">
                    <div className="celebratePerallal">
                      {fangroup?.my_superstar?.first_name}{" "}
                      {fangroup?.my_superstar?.last_name}
                    </div>
                    <div className="vs">VS</div>
                    <div className="celebratePerallal">
                      {fangroup?.another_superstar?.first_name}{" "}
                      {fangroup?.another_superstar?.last_name}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FanGroupSearch;
